import React, { useEffect, useState } from 'react'
import loadable from '@loadable/component'

const VimeoFrame = loadable(() => import('../widgets/vimeoFrame'))

const VideoModal = ({ videoUrl, isOpen, closeVideoModalCallback }) => {
  const [classes, setClasses] = useState('fade')
  const [videoId, setVideoId] = useState()
  const [videoHash, setVideoHash] = useState()

  useEffect(() => {
    setClasses(isOpen ? 'in' : 'fade')
  }, [isOpen])

  useEffect(() => {
    let myVideoHash = null
    let myVideoId = null
    
    if (videoUrl) {
      const tokens = videoUrl.split('/')
      myVideoId = tokens[tokens.length - 1]
      let queryParams = myVideoId.split('?')

      myVideoId = queryParams[0]

      if (queryParams.length > 1) {
        queryParams = queryParams[1].split('&')
        for (let index = 0; index < queryParams.length; index++) {
          try {
            const queryParam = queryParams[index].split('=')
            if (queryParam[0] === 'h') {
              myVideoHash = queryParam[1]
            }
          } catch (error) {}
        }
      }
    }

    setVideoId(myVideoId)
    setVideoHash(myVideoHash)
  }, [videoUrl])

  return (
    <>
      {videoId ? (
        <>
          <div
            className={'modal modal__video ' + classes}
            id="modal__video"
            tabIndex="-1"
            role="dialog"
          >
            <div
              className="modal-dialog modal-dialog-centered modal__video--dialog"
              role="document"
            >
              <div className="modal-content modal__video--content">
                <div className="modal-body modal__video--body">
                  <button
                    type="button"
                    className="close modal__video--close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span
                      aria-hidden="true"
                      className="icon-Close-Bold"
                      onClick={closeVideoModalCallback}
                    ></span>
                  </button>
                  <div className="embed-responsive embed-responsive-16by9">
                    <VimeoFrame videoId={videoId} videoHash={videoHash} />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            id="modal__video--backdrop"
            className={'modal-backdrop modal__video--backdrop ' + classes}
          ></div>
        </>
      ) : null}
    </>
  )
}

export default VideoModal
